import React from 'react';
import mainLogo from "../assets/images/iasg_mid_logo.png";
import enhanceLogo from "../assets/images/enhance_logo_white.svg";

const quickLinks = [
  { label: 'About', href: '#about' },
  { label: 'Program', href: '#program' },
  { label: 'Registration', href: '#registration' },
  // { label: 'Venue', href: '#venue' },
  { label: 'Organizing Committee', href: '#speakers' },
];

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-col footer-brand">
            <div className="footer-logo">
              {/* <span className="footer-logo-icon">IASG</span> */}
              <img src={mainLogo} alt="IASG Logo" className="footer-logo-image" />
              <span className="footer-logo-text">Mid-Term Conference 2026</span>
            </div>
            <p className="footer-desc">
              G.I. Oncology: From Basics to Clinical Practice.<br /> 28 & 29 March 2026, Patna, Bihar.
            </p>
          </div>
          <div className="footer-col">
            <h3 className="footer-heading">Quick Links</h3>
            <ul className="footer-links">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="footer-link">{link.label}</a>
                </li>
              ))}
            </ul>
          </div>
          <div className="footer-col">
            <h3 className="footer-heading">Conference Secretariat</h3>
            <ul className="footer-contact">
              <li>
                <i className="ri-mail-line" aria-hidden="true" />
                <a href="mailto:iasgmidterm2026@gmail.com">iasgmidterm2026@gmail.com</a>
              </li>
              <li>
                <i className="ri-phone-line" aria-hidden="true" />
                <span>+91 99 2134 96, +91 96 9357 4748</span>
              </li>
              <li>
                <i className="ri-map-pin-line" aria-hidden="true" />
                <span>Room No - 168 (First Floor), Department of G.I Surgery, Indira Gandhi Institute of Medical Sciences (IGIMS), Sheikhpura, Patna-800014 (Bihar)</span>
              </li>
            </ul>
          </div>
          <div className="footer-col">
            <h3 className="footer-heading">Stay Updated</h3>
            <div className="footer-social">
              <a href="#twitter" className="footer-social-link" aria-label="Twitter">
                <i className="ri-twitter-x-line" aria-hidden="true" />
              </a>
              <a href="#facebook" className="footer-social-link" aria-label="Facebook">
                <i className="ri-facebook-fill" aria-hidden="true" />
              </a>
              <a href="#linkedin" className="footer-social-link" aria-label="LinkedIn">
                <i className="ri-linkedin-fill" aria-hidden="true" />
              </a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p className="footer-copy">
            © IASG Mid-Term Conference 2026. All Rights Reserved.
          </p>
          <div className="footer-legal">
            <a href="#privacy">Privacy Policy</a>
            <span className="footer-legal-sep">|</span>
            <a href="#terms">Terms of Service</a>
            <span className="footer-legal-sep">|</span>
            <a className="footer-enhance-link" href="https://www.enhance.events/" target="_blank" rel="noopener noreferrer">
            <span>Powered by</span>
              <img src={enhanceLogo} alt="Enhance Logo" className="footer-enhance-logo" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
